import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'  // 引入组件库
import 'element-ui/lib/theme-chalk/index.css'  // 引入样式
 
Vue.use(ElementUI)  // 全局注册
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
